import { render, staticRenderFns } from "./PDFTabViewer.vue?vue&type=template&id=59464d28"
import script from "./PDFTabViewer.vue?vue&type=script&lang=js"
export * from "./PDFTabViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports